<template>
    <div>
        <b-table v-if="reports.length > 0" class="table table-striped" :items="reports" :fields="fields" stacked="sm">
            <template slot="actions" slot-scope="row">
                <b-button-group class="">
                    <router-link class="btn btn-xs btn-success"
                                v-b-tooltip.hover title="Show"
                                :to="{name : 'report.show', params: { report_id: row.item.id }}">
                        <font-awesome-icon icon="eye" />
                    </router-link>
                    <router-link class="btn btn-xs btn-primary"
                                v-b-tooltip.hover title="Edit"
                                :to="{name : 'report.edit', params: { report_id: row.item.id }}">
                        <font-awesome-icon icon="edit" />
                    </router-link>
                    <b-button variant="danger"
                            v-b-tooltip.hover title="Delete"
                            @click="del(row.item.id, row.index)">
                        <font-awesome-icon icon="trash-alt" />
                    </b-button>
                </b-button-group>
            </template>
            <template slot="updated" slot-scope="row">
				{{row.item.updated_at}}
			</template>
        </b-table>
    </div>
</template>

<script>
    export default {
        props: {
            reports: {
                type: Array,
                required: true
            },
            fields: {
                type: Array,
                default: () =>  ['title', 'status', 'updated', 'actions']
            }
        },
        data() {
            return {

            }
        },
        methods: {            
            del(id, index) {
                this.$swal({
                    title: 'Be careful',
                    text: "Are you sure?",
                    type: 'warning',
                    width: '350px',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Confirm'
                }).then((result) => {
                    if (result.value) {
                        let payload = {
                            id : id,
                            index: index
                        };
                        this.$store.dispatch('reports/delete', payload);
                    }
                })
            },
        },
    }
</script>
